export const ROOT = '/';
export const USER_MANAGEMENT = '/user-management';
export const TREATIES = '/treaties';
export const DATA_ROOMS = '/data-rooms';
export const DIRECTORY_BROWSER = '/treaties/:cedantId/:directoryId';
export const TREATY_BROWSER = '/treaties/:cedantId/';
export const FILE_DETAILS = '/file/:cedantId/:fileId';
export const SEARCH = '/search';
export const DLT_NODE_LIST = '/dlt-details/:cedantId';
export const PROBLEMATIC_FILES = '/problematic-files';
